import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { InviteToApplyService } from '@shared/invite-to-apply/services/invite-to-apply.service';
import { sendInviteToApply } from '@shared/invite-to-apply/store/invite-to-apply.actions';
import { InviteToApply } from '@shared/models/invite-to-apply';

@Component({
  selector: 'mojo-invite-to-apply-modal',
  templateUrl: './invite-to-apply-modal.component.html',
  styleUrls: ['./invite-to-apply-modal.component.scss'],
})
export class InviteToApplyModalComponent implements OnDestroy {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: InviteToApply,
    private dialogRef: MatDialogRef<InviteToApplyModalComponent>,
    private inviteToApplyService: InviteToApplyService,
    private store: Store<{}>,
  ) {}

  sendInviteToApply() {
    this.store.dispatch(sendInviteToApply({ inviteToApply: this.data }));
    this.closeDialog();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.closeDialog();
  }
}
